module.exports = __webpack_public_path__ + "img/salary_report.5cb37391.png";